export default __webpack_public_path__ + "static/media/Audio-ANTZA.eeac8bcc.png";